// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__Bu58O","cssload-spin":"Loading_cssload-spin__xtKP1","wrapper":"Loading_wrapper__yNd4s"};